import { versementErrors } from "./errorVersementMap";

export const FormatErrorVersement = (errorResponse) => {

  if (!errorResponse) {
    return {
      title: "Erreur inconnue",
      message: "Une erreur inattendue est survenue."
    };
  }

  if (typeof errorResponse === "object" && !errorResponse.codeHttp) {
    const messages = Object.entries(errorResponse)
      .map(([field, msg]) => `${field}: ${msg}`)
      .join(" | ");
    return {
      title: "Erreur de validation",
      message: messages
    };
  }

  const codeHttp = errorResponse.codeHttp || errorResponse.status || errorResponse.statusCode;
  const codeIntern = errorResponse.codeIntern || errorResponse.error || errorResponse.code;
  const description = errorResponse.description || errorResponse.message || "Une erreur est survenue.";

  const byStatus = versementErrors[codeHttp];

  if (byStatus && byStatus[codeIntern]) {
    return {
      title: `Erreur ${codeHttp}`,
      message: byStatus[codeIntern]
    };
  }

  return {
    title: `Erreur ${codeHttp || ""}`,
    message: description
  };
};